import React from 'react'

import type { Image } from '../../modules/Post/types'
import { UploadedImage } from '../UploadedImage/UploadedImage'
import { PostGalleryImage } from './PostGalleryImage'
import { SortableGrid } from './SortableGrid'
import * as S from './styled'

type Props = {
  images: Image[]
  onImageRemove: (imageIndex: number) => void
  onImageSort: (oldIndex: number, newIndex: number) => void
}

export const PostGallery = ({ images, onImageRemove, onImageSort }: Props) => {
  const handleImageRemove = (id: string) => {
    const index = images.findIndex((image) => image.id === parseInt(id))

    onImageRemove(index)
  }

  return (
    <SortableGrid
      items={images.map((image) => image.id.toString())}
      // eslint-disable-next-line react/no-unstable-nested-components
      draggedElement={(imageId) => {
        const activeImage = images.find((image) => image.id.toString() == imageId)

        if (!activeImage) return

        return (
          <S.ImageContainer count={images.length} style={{ cursor: 'grabbing' }}>
            <UploadedImage image={activeImage.image} objectFit="contain" />
          </S.ImageContainer>
        )
      }}
      onSort={onImageSort}
    >
      <S.ImagesContainer count={images.length}>
        {images.map((image) => (
          <PostGalleryImage
            key={image.id.toString()}
            id={image.id.toString()}
            image={image.image}
            count={images.length}
            onImageRemove={handleImageRemove}
          />
        ))}
      </S.ImagesContainer>
    </SortableGrid>
  )
}
